import { SENTRY_ERROR_FALLBACK } from '../constants/sentry'

export function SentryErrorFallback() {
  return (
    <p role="alert">
      <strong>{SENTRY_ERROR_FALLBACK.title}</strong>
      {` ${SENTRY_ERROR_FALLBACK.hint}`}
    </p>
  )
}
